window.quadrinhosPage = {
    
    consultingForm : () => {
        
        $(".row-consulting-form").slideDown('normal', function() {
                $(".link-consulting").slideUp();
            });

	},

};